import Instance from "../../../../Axios";

// New Actions for the app

const GetCredTipoCombustiveis = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/tipoCombustiveis`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_TIPO_COMBUSTIVEIS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredTipoCombustiveis;